import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Container, Grid, IconButton, List, ListItemButton } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { darken, styled } from '@mui/material/styles';
import { withStyles, withTheme } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import CustomizedSnackbars from '../../components/material-snackbars';
import Api from '../../services/api';
import { AbilityContext } from '../../config/ability-context'
import { FormattedMessage, injectIntl } from 'react-intl';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import * as componentActions from '../../redux/actions/knowledgebases';
import * as articleActions from '../../redux/actions/articles';
import Badge from '@mui/material/Badge';
import moment from 'moment';
import { browserHistory } from "../../helpers/history";
import * as FileService from '../../services/attachment.service';
import { PapiroConsole } from 'src/utils/papiroConsole';
import Header from 'src/components/header-external';
import Modal from 'src/components/modal-external/modal-principal';
import Footer from 'src/components/footer-external';
import LogoMarca from 'src/images/new-logo2-cmtech.png'

import CalledServicesSettingsExternalFormList from "../client-portal-external/components/called-services-settings-external-form-list";
import CommonSearchExternal from 'src/components/client-portal/common-search-external';
import CommonBackButtonExternal from 'src/components/client-portal/common-back-button-external';
import CommonPaginateSkeleton from 'src/components/client-portal/common-paginate-skeleton';
import CommonTotalPagesCount from 'src/components/client-portal/common-total-pages-count';
import KnowledgeBaseAttachmentsDialog from 'src/components/client-portal/common-knowledget-base-attachments-dialog';
import KnowledgeBaseExternalHeaderSearchList from 'src/components/knowledgebase-external-components/knowledgebase-external-header-searh-list';

import CustomIcon from 'src/components/custom-icon';

import DescriptionIcon from '@mui/icons-material/Description';
import Search from '@mui/icons-material/Search';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

import './style.css';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

class ExternalKnowledgeBases extends Component {

    constructor(props) {
        super(props);

        const { theme } = this.props;

        let filters = [
            { name: "Palavras-Chaves", id: "keyword" },
            { name: "Titulo", id: "title" },
            /*{ name: "Autor", id: "createduser" },
            { name: "Patrimônios", id: "patrimony" },
            { name: "Descrição", id: "description" },
            */
        ];

        this.initialKnowledgeBaseItem = {
            id: 0,
            title: '',
            description: '',
            knowledgebasepatrimonies: [],
            knowledgebaseattachments: [],
            knowledgebasekeywords: [],
        }

        this.initialEvaluation = {
            id: 0,
            knowledgebaseid: 0,
            wasuseful: null,
            description: '',
            createdat: moment().format('YYYY/MM/DD HH:mm:ss'),
            updatedat: moment().format('YYYY/MM/DD HH:mm:ss'),
        }

        this.state = {
            loading: false,
            loadingKnowledge: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultList: [],

            selectedKnowledgeBase: null,

            primaryColor: theme.palette.primary.main,

            contentFilter: '',
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            hirerId: 0,
            searchValue: '',
            filterSelected: 0,
            filters: filters,
            knowledgeBaseDetailsDialogOpen: false,
            knowledgeBaseItem: this.initialKnowledgeBaseItem,
            evaluation: this.initialEvaluation,
            clientportal: {},
            createCalledDialogOpen: false,
            calledServiceSettingsList: [],
            logoimagesrc: '',
            mainimagesrc: '',
            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            searchValueBar: "",
        };

        this.isClient = true;

        this.handleBack = this.handleBack.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.callSearch = this.callSearch.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.changeValues = this.changeValues.bind(this);
        this.addFilter = this.addFilter.bind(this);
        this.knowledgeBaseDetails = this.knowledgeBaseDetails.bind(this);
        this.getHirerId = this.getHirerId.bind(this)

        this.getCustomColorPrimary = this.getCustomColorPrimary.bind(this)

        this.renderKnowledgeBasesSections = this.renderKnowledgeBasesSections.bind(this)
        this.renderKnowledgeBaseLabel = this.renderKnowledgeBaseLabel.bind(this)
        this.handleSelectedKnowledgeBase = this.handleSelectedKnowledgeBase.bind(this)

        localStorage.setItem('newFilter', '');
        localStorage.setItem('newSearch', '');
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.location && nextProps.location.state === 'reload') {
            await this.componentDidMount();
        }
    }

    async componentDidMount() {
        this.setState({ loading: true })
        document.title = this.state.appName;
        await this.getHirerId()
        if (!this.state.clientportal || !this.state.clientportal.id || !this.state.clientportal.id <= 0) {
            PapiroConsole.log("Sem client portal")
            await this.getClientPortal()
        }
        var generalSearchKnowledgeBase = JSON.parse(localStorage.getItem("generalSearchKnowledgeBase"))
        if (generalSearchKnowledgeBase != null && generalSearchKnowledgeBase.title) {
            this.setState({
                filterSelected: "title",
                searchValue: generalSearchKnowledgeBase.title
            }, () => {
                this.addFilter()
            })
        }
        await this.getItens(1, true)
        this.setState({ loading: false })
    }

    async changeValues(event, stateName) {
        const name = stateName ? stateName : event.target.name;

        const value = event && event.target && event.target.value != null ? event.target.value : event;

        this.setState({ [name]: value });
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value,
        })
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getItens(page);
    }

    handleBack = () => {
        const { history, match } = this.props;
        if (history.length > 1) {
            browserHistory.goBack();
        } else {
            history.push(`/${match.params.lang}/client-portal-external`);
        }
    }

    knowledgeBaseDetailsClose = _ => this.setState({ knowledgeBaseDetailsDialogOpen: false, knowledgeBaseItem: this.initialKnowledgeBaseItem, evaluation: this.initialEvaluation })

    knowledgeBaseDetails = async (item) => {
        this.setState({ knowledgeBaseDetailsDialogOpen: true, knowledgeBaseItem: item })
    }

    searchArticle = () => {
        this.props.addCurrentSearch(this.state.searchValueBar)
        this.props.history.push(`/${this.props.match.params.lang}/article-list-external`)
    }

    setPagination(count, page) {

        let totalPage = Math.ceil(count / 10);
        this.setState({ totalPages: totalPage })
        if (count > 0) {
            if (page == 1) {
                if (count < 10) {
                    this.setState({ pageStart: 1, pageEnd: count });
                } else {
                    this.setState({ pageStart: 1, pageEnd: 10 });
                }
            } else {
                let pageStart = ((page - 1) * 10) + 1;
                if (count >= page * 10) {
                    this.setState({ pageStart: pageStart, pageEnd: page * 10 });
                } else {
                    this.setState({ pageStart: pageStart, pageEnd: count });
                }
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 });
        }

    }

    async addFilter() {
        const intl = this.props.intl;
        if (this.state.filterSelected == 0) {
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "caled.list.notification.select.one.filter.option" })
            });
        } else {
            let newFilter = localStorage.getItem('newFilter');
            let newSearch = localStorage.getItem('newSearch');

            if (this.state.searchValue != '' && this.state.filterSelected != 0) {

                if (this.state.filterSelected === "open") {
                    let date = this.state.searchValue.split("/");
                    if (date.length === 3) {
                        date = `${date[2]}-${date[1]}-${date[0]}`
                    }

                    newFilter += this.state.filterSelected + "@";
                    newSearch += date + "@";

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {

                        if (this.state.filters[i].id === this.state.filterSelected) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    this.setState({
                        contentFilter: this.state.contentFilter + nameField + ": " + this.state.searchValue + "\n"
                    });

                } else {

                    newFilter += this.state.filterSelected + "@";
                    newSearch += this.state.searchValue + "@";

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {
                        if (this.state.filters[i].id === this.state.filterSelected) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    this.setState({
                        contentFilter: this.state.contentFilter + nameField + ": " + this.state.searchValue + "\n"
                    });
                }

                localStorage.setItem("newFilter", newFilter);
                localStorage.setItem("newSearch", newSearch);

                this.setState({
                    searchValue: ''
                })
            }
        }
    }

    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page: 1 });
    }

    callSearch = async () => {
        const { intl } = this.props;

        if (this.state.filterSelected == 0) {
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "caled.list.notification.select.one.filter.option" })
            });

            return;
        }

        await this.addFilter();

        if (this.state.contentFilter && this.state.contentFilter.length > 0) {
            await this.getItens(1);
        }
    }

    async clearFields() {
        await this.setState({ filterSelected: 0, searchValue: '', page: 1, contentFilter: '' })
        localStorage.setItem('newFilter', '');
        localStorage.setItem('newSearch', '');
        this.getItens(1);
    }

    getHirerId = async () => {
        await Api.get(`/configs/cancreateclientusersexternal`)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0)
                            this.setState({ hirerId: result.data.data.hirerid }
                            )
                        else
                            browserHistory.goBack()
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    getItens = async (page = 1, mount = false) => {
        if (!mount) {
            this.setState({ loadingKnowledge: true })
        }

        const customColorWithoutImportant = this.getCustomColorPrimary(0.05, true);
        const customIconColor = this.getCustomColorPrimary(0.1, true);

        let url = `/knowledgebasekeywords/external/paginate/hirer/${this.state.hirerId}?page=${page}`;

        let newFilter = localStorage.getItem('newFilter');
        let newSearch = localStorage.getItem('newSearch');

        if (newFilter != '' && newSearch != '') {
            url += `&search=${newSearch}&field=${newFilter}`;
            this.setState({ dataFilter: true });
        }

        await Api.get(url)
            .then(result => {
                if (result.data.success) {

                    let count = result.data.count;
                    this.setState({ count: count });
                    this.setPagination(count, page);

                    let defaultExpand = false
                    let generalSearchKnowledgeBase = JSON.parse(localStorage.getItem("generalSearchKnowledgeBase"))
                    localStorage.removeItem("generalSearchKnowledgeBase")

                    const newFormmatedList = result.data.data.map(item => {

                        let knowledgebaseknowledgebases = [];

                        item.knowledgebaseknowledgebases.sort((a, b) => {
                            const hasOrderA = a.order != null && a.order !== 0;
                            const hasOrderB = b.order != null && b.order !== 0;

                            const hasOrderAAndOrderB = hasOrderA && hasOrderB;
                            const isEqualOrderAAndOrderB = hasOrderAAndOrderB && (a.order === b.order);

                            if (hasOrderAAndOrderB && !isEqualOrderAAndOrderB) {
                                return a.order - b.order;
                            }

                            if (hasOrderA && !hasOrderB) return -1;
                            if (!hasOrderA && hasOrderB) return 1;

                            if (a.title && b.title) {
                                return a.title.localeCompare(b.title);
                            }

                            return a.id - b.id;
                        });

                        if (item.knowledgebaseknowledgebases != null) {
                            item.knowledgebaseknowledgebases.map((kbItem, kbIdx) => {

                                let keywords = "";
                                let keyWordsList = [];
                                kbItem.knowledgebaseknowledgebasekeywords.map(linkKb => {
                                    if (linkKb && linkKb.knowledgebasekeyword && linkKb.knowledgebasekeyword.word)
                                        keywords = linkKb.knowledgebasekeyword.word + ", " + keywords;
                                    keyWordsList.push(<div className='kb-key' style={{ height: '100%', color: customColorWithoutImportant, borderColor: customColorWithoutImportant, wordBreak: "break-word !important", width: "95%" }}>{linkKb.knowledgebasekeyword.word}</div>)
                                })
                                keywords = keywords.slice(0, -2);

                                keyWordsList = keyWordsList.sort(function (a, b) {
                                    if (a.title < b.title) { return -1 }
                                    if (a.title > b.title) { return 1 }
                                    return 0
                                })

                                if (kbItem.knowledgebaseknowledgebasekeywords && kbItem.knowledgebaseknowledgebasekeywords.length > 2) {
                                    let keywordsSublist = kbItem.knowledgebaseknowledgebasekeywords.slice(2)
                                    let moreKeyWords =
                                        <HtmlTooltip
                                            interactive
                                            placement="bottom-start"
                                            title={
                                                <React.Fragment className='kb-tooltip-root'>
                                                    <div className='kb-tooltip'>
                                                        {keywordsSublist.map((kItem, key) => { return <div className='kb-key kb-key-tooltip' style={{ height: '100%', color: customColorWithoutImportant, borderColor: customColorWithoutImportant, wordBreak: "break-word !important", width: "95%" }} key={key}>{kItem.knowledgebasekeyword.word}</div> })}
                                                    </div>
                                                </React.Fragment>
                                            }
                                        >
                                            <div className='kb-key' style={{ height: '100%', color: customColorWithoutImportant, borderColor: customColorWithoutImportant }}>+{(keyWordsList.length - 2)}</div>
                                        </HtmlTooltip>
                                    keyWordsList.push(moreKeyWords)
                                }
                                knowledgebaseknowledgebases.push(<div className='kb-card' onClick={() => this.knowledgeBaseDetails(kbItem)}>
                                    <div className='kb-card-more'>
                                        <Tooltip title={<h5><FormattedMessage id="details" /></h5>}>
                                            <IconButton color="primary" aria-label="details">
                                                <CustomIcon icon={DescriptionIcon} color={customIconColor} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>

                                    <div className='kb-card-details' style={{ width: "100%" }}>
                                        <div className='kb-title'>{kbItem.title}</div>
                                        <div className='kb-key-title'>#{kbItem.id}</div>
                                        {(keyWordsList && keyWordsList.length > 0 && keyWordsList.length <= 2) &&
                                            <div className='kb-key-title'>Palavras chave: <div className='kb-keys' style={{ overflowWrap: "break-word" }}>{keyWordsList.map(keyItem => { return keyItem })}</div></div>
                                        }
                                        {(keyWordsList && keyWordsList.length > 2) &&
                                            <div className='kb-key-title'>Palavras chave: <div className='kb-keys' style={{ overflowWrap: "break-word" }}>{keyWordsList.map((keyItem, keyIdx) => {
                                                if (keyIdx < 2 || (keyWordsList.length - 1 === keyIdx)) return keyItem
                                            })}</div></div>
                                        }
                                    </div>
                                </div>)
                                if (generalSearchKnowledgeBase && kbItem.id == generalSearchKnowledgeBase.id) {
                                    defaultExpand = true
                                    this.knowledgeBaseDetails(kbItem)
                                }
                            })
                        }

                        if (defaultExpand) {
                            defaultExpand = false
                            generalSearchKnowledgeBase = null
                        }

                        return {
                            ...item,
                            knowledgebaseknowledgebases
                        }

                    });
                    this.setState({ resultList: newFormmatedList, selectedKnowledgeBase: newFormmatedList && newFormmatedList.length > 0 ? newFormmatedList[0] : null });
                }
                else {
                    this.setState({
                        loading: false, loadingKnowledge: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, loadingKnowledge: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });

        if (!mount) {
            this.setState({ loadingKnowledge: false })
        }
    };

    async getClientPortal() {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${this.state.hirerId}`)
            .then(result => {
                if (result.data && result.data.success) {
                    const data = result.data.data;

                    this.setState({
                        clientportal: data
                    })
                    if (data.logoimage) {
                        PapiroConsole.log('data.logoimage')
                        PapiroConsole.log(data.logoimage)
                        this.getImageFile(data.logoimage, "logoimagesrc")
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            PapiroConsole.log('image')
                            PapiroConsole.log(image)
                            this.getImageFile(image, "logoimagesrc")
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                    if (data.mainimage) {
                        this.getImageFile(data.mainimage, 'mainimagesrc')
                    }
                } else {
                    this.setState({ loading: false })
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                PapiroConsole.log("err")
                PapiroConsole.log(err)
                if (err.response && err.response.status == 404) {
                    return
                }
                this.setState({ loading: false })
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    handleDelete(chipToDelete) {
        let valueAtual = this.state.contentFilter.split("\n")
        var newvalue = "";
        valueAtual.map(item => {
            if (item != "" && item != valueAtual[chipToDelete]) {
                newvalue = newvalue + item + " \n"
            }
        })

        this.setState({
            contentFilter: newvalue
        });

        if (newvalue == "") {
            this.clearFields()
        }

    };

    useStyles = _ => {
        return withStyles({
            ImageList: {
                width: "100%",
                height: 100,
            },
        });
    }

    getCalledFile = async (attachment) => {
        const intl = this.props.intl;

        let url = await FileService.getFileDownloadLink(attachment.id);
        if (url && url.data && url.data.data && url.data.success) {

            window.open(`${url.data.data}`, '_blank');
        } else {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "file.not.found" })
            });
        }
    }

    copyFileLink = async (attachment) => {
        const intl = this.props.intl;

        let url = await FileService.getFileDownloadLink(attachment.id);
        if (url && url.data && url.data.data && url.data.success) {

            navigator.clipboard.writeText(url.data.data)
            this.knowledgeBaseDetailsClose();

            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "success",
                notificationMessage: "Link de download copiado!"
            })
        } else {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "file.not.found" })
            });
        }
    }

    getImageFile = async (image, stateKey) => {
        let xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*')
        try {
            xhttpImage.send()
            let ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                this.setState({ [stateKey]: ImageData.data })
            }
        }
        catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        }
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({
            createCalledDialogOpen: true,
            calledServiceSettingsList: calledServiceSettingsList
        })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    handleSelectedKnowledgeBase = (id) => {
        const { resultList, selectedKnowledgeBase } = this.state
        const newSelectedKnowledgeBase = resultList.find((kb) => kb.id === id)

        if (newSelectedKnowledgeBase && newSelectedKnowledgeBase.id !== (selectedKnowledgeBase && selectedKnowledgeBase.id)) {
            this.setState({ selectedKnowledgeBase: newSelectedKnowledgeBase })
        }
    }

    renderKnowledgeBaseLabel(props) {
        const { selectedKnowledgeBase } = this.state;
        const { id, word, count } = props;

        const isActive = id === (selectedKnowledgeBase && selectedKnowledgeBase.id);

        const customColor = isActive ? this.getCustomColorPrimary(0.1, true) : 'black';

        return (
            <li
                key={id}
                style={{
                    paddingBottom: "8px",
                    width: '100%',
                    "&:last-child": {
                        paddingBottom: 0,
                    }
                }}
            >
                <ListItemButton
                    onClick={() => this.handleSelectedKnowledgeBase(id)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderRadius: 2,
                        gap: 1,
                        width: '100%',
                    }}
                >
                    <Tooltip title={word} placement="top" arrow>
                        <Typography
                            variant="h5"
                            children={word}
                            sx={{
                                fontSize: '18px',
                                color: customColor,
                                fontWeight: isActive ? 600 : 300,
                                transition: "all 0.1s ease-out",
                            }}
                            noWrap
                        />
                    </Tooltip>

                    <Badge badgeContent={count || 0} color="primary">
                        <CustomIcon icon={EmojiObjectsIcon} color={customColor} />
                    </Badge>
                </ListItemButton>
            </li>
        )
    }

    renderKnowledgeBasesSections = () => {
        const { resultList } = this.state;

        return (
            <List sx={{ width: '100%' }} component="nav" aria-labelledby="nested-list-subheader">
                {resultList.map(this.renderKnowledgeBaseLabel)}
            </List>
        )
    }

    getCustomColorPrimary = (darkenValue = 0, customIcon = false) => {
        const { clientportal, primaryColor } = this.state;
        const defaultClientColor = clientportal?.defaultcolor ? clientportal.defaultcolor : primaryColor;

        const customColor = darken(defaultClientColor, darkenValue);

        if (customIcon) return customColor;

        return `${customColor} !important`;
    }

    render() {
        const { classes, theme } = this.props;
        const intl = this.props.intl;
        const { clientportal, logoimagesrc, mainimagesrc, loading, loadingKnowledge } = this.state

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        const classes2 = this.useStyles();

        return (
            <div>
                <main className={classes.contentExternal}>
                    <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, padding: 0, minHeight: "100vh" }}>
                        <Grid container marginTop={0} spacing={6} direction="column" justifyContent="space-between" minHeight="100vh">
                            <Grid item container style={{ paddingTop: 0 }} spacing={2}>
                                <Header
                                    intl={this.props.intl}
                                    clientportal={clientportal}
                                    calledservicesettings={clientportal.calledservicesettingsclientportals}
                                    language={this.props.match.params.lang}
                                    openCreateCalledDialog={this.openCreateCalledDialog}
                                    logoimagesrc={logoimagesrc}
                                    loading={loading}
                                />

                                <CommonSearchExternal
                                    state={this.state}
                                    clientportal={clientportal}
                                    loading={loading}
                                    nameTextField={"searchValueBar"}
                                    handleChange={this.handleChange}
                                    searchArticle={this.searchArticle}
                                    mainImageSrc={mainimagesrc}
                                />

                                <Grid item sm={12} container marginX="15vw" maxWidth={'60vw'} >
                                    <CommonBackButtonExternal
                                        clientportal={clientportal}
                                        loading={loading}
                                        handleBack={this.handleBack}
                                    />
                                </Grid>

                                {/* { Search SKELETON - CARD } */}
                                <KnowledgeBaseExternalHeaderSearchList
                                    clientPortal={clientportal}
                                    state={this.state}
                                    loading={loading}
                                    loadingKnowledge={loadingKnowledge}

                                    classes={classes}

                                    clearFields={this.clearFields}
                                    callSearch={this.callSearch}
                                    addFilter={this.addFilter}

                                    handleDelete={this.handleDelete}
                                    changeValues={this.changeValues}
                                />


                                {/* { Paginate SKELETON - LIST } */}
                                {(loading || loadingKnowledge) && (
                                    <Grid container marginX="15vw" sx={{ pt: 2, pl: 2, marginBottom: '12px', marginTop: '8px' }}>
                                        <CommonPaginateSkeleton
                                            loading={true}
                                            marginInline='15vw'
                                            isColumnFilter
                                        />
                                    </Grid>
                                )}

                                {(!loading && !loadingKnowledge) && (
                                    <React.Fragment>
                                        <Grid container marginX="15vw" sx={{ pt: 2, pl: 2, marginBottom: '12px', marginTop: '8px' }}>
                                            <Card className="background-title-search" sx={{ width: "100%" }}>
                                                {!!this.state.selectedKnowledgeBase && !!this.state.selectedKnowledgeBase?.knowledgebaseknowledgebases?.length
                                                    ? (
                                                        <Grid container xs={12} spacing={0}>
                                                            <Grid container item xs={2} pt={2} pb={2} pr={0} pl={2}>
                                                                {this.renderKnowledgeBasesSections()}
                                                            </Grid>

                                                            {!!this.state.selectedKnowledgeBase && !!this.state.selectedKnowledgeBase?.knowledgebaseknowledgebases?.length &&
                                                                <Grid container item xs={10} pt={4} pb={4} pl={1} pr={3}>
                                                                    <div className='material-table'>
                                                                        {(this.state.selectedKnowledgeBase?.knowledgebaseknowledgebases || []).map(item => {
                                                                            return item
                                                                        })}
                                                                    </div>
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    )
                                                    : (
                                                        <Grid item xs={12} sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            padding: '40px',
                                                            borderRadius: '8px',
                                                            textAlign: 'center'
                                                        }}>
                                                            <CustomIcon icon={Search} color={this.getCustomColorPrimary(0, true)} iconSx={{ fontSize: 60, marginBottom: 2 }} />

                                                            <Typography variant="h5" sx={{ color: theme.palette.text.primary, marginBottom: 1 }}>
                                                                {intl.formatMessage({ id: "content.not.found" })}
                                                            </Typography>
                                                            <Typography variant="body1" sx={{ color: theme.palette.text.secondary }}>
                                                                {intl.formatMessage({ id: "try.different.search" })}
                                                            </Typography>
                                                        </Grid>
                                                    )}
                                            </Card>
                                        </Grid>

                                        <Grid item container marginX="15vw" style={{ marginBottom: 12, marginTop: 8 }}>
                                            <CommonTotalPagesCount state={this.state} onChangePaginate={this.onChangePaginate} clientportal={clientportal} />
                                        </Grid>
                                    </React.Fragment>
                                )}

                            </Grid>
                            <Footer
                                intl={intl}
                                clientportal={clientportal}
                                setLoading={loading => this.setState({ loading: loading })}
                                loading={loading}
                            />
                        </Grid>

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                        <Modal
                            intl={intl}
                            title={<strong style={{ color: this.state.clientportal.defaulttextcolor }}>{this.state.clientportal.createcalledpagetitle || intl.formatMessage({ id: "choose.form" })}</strong>}
                            open={this.state.createCalledDialogOpen}
                            onClose={this.closeCreateCalledDialog}
                            contentPadding={false}
                            maxWidth="md"
                            children={
                                <CalledServicesSettingsExternalFormList
                                    calledServiceSettingsList={this.state.calledServiceSettingsList}
                                    clientportal={clientportal}
                                />
                            }
                        />
                    </Container>

                    <KnowledgeBaseAttachmentsDialog
                        open={this.state.knowledgeBaseDetailsDialogOpen}
                        onClose={this.knowledgeBaseDetailsClose}
                        knowledgeBaseItem={this.state.knowledgeBaseItem}
                        clientportal={clientportal}
                        classes={classes}
                        classes2={classes2}
                        getCalledFile={this.getCalledFile}
                        copyFileLink={this.copyFileLink}
                        loading={this.state.loading || this.state.loadingKnowledge}
                    />
                </main>
            </div>
        )

    }
}
ExternalKnowledgeBases.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        ...componentActions,
        ...articleActions
    }, dispatch);
export default withTheme(injectIntl(connect(null, mapDispatchToProps)(withStyles(Styles)(ExternalKnowledgeBases))));
ExternalKnowledgeBases.contextType = AbilityContext;
